import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option:
      "a) Saber se as tecnologias do cliente são compatíveis ao SAI ES Stefanini",
    correct: false,
  },
  {
    option:
      "b) Custos inviabilizatórios de implementação e sustentação do SAI ES",
    correct: false,
  },
  {
    option:
      "c) Integrar - de forma segura, responsável e consequente – tecnologias IA emergentes nas ofertas que proporcionam estabilidade e performance na Infraestrutura cliente (AI TRiS)",
    correct: true,
  },
  {
    option:
      "d) Avaliar se o faturamento no cliente será menor em função da redução de incidentes",
    correct: false,
  },
  {
    option: "e) Normas de segurança que impedem a implementação",
    correct: false,
  },
];

export default function Question34(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question34: {
          title:
            "Qual a principal preocupação da Stefanini no desenvolvimento do SAI ES?",
          option: option.option,
          correct: option.correct,
          order: 34
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Qual a principal preocupação da Stefanini no desenvolvimento do SAI ES?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
